import { Routes } from '@angular/router';
import { RouterTools } from '@sol/components';
import { AsmAuthority } from '@asm/components-core/models/asm-authority';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';

export const routesPartner: Routes = [
  // Dashboard
  RouterTools.ofLazy(
    AsmRouteId.partner_dashboard,
    () =>
      import('@asm/components-partner-management/components/partner/asm-partner-dashboard-page/asm-partner-dashboard-page.component').then(
        m => m.AsmPartnerDashboardPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_APP],
  ),

  // Scopes
  RouterTools.ofLazy(
    AsmRouteId.partner_scopes,
    () =>
      import('@asm/components-partner-management/components/partner/asm-partner-scopes-page/asm-partner-scopes-page.component').then(
        m => m.AsmPartnerScopesPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_SCOPES],
  ),
  RouterTools.ofRedirect(AsmRouteId.partner_scopes_scope, AsmRouteId.partner_scopes_scope_overview),
  RouterTools.ofLazy(
    AsmRouteId.partner_scopes_scope_overview,
    () =>
      import('@asm/components-partner-management/components/partner/asm-partner-scope-overview-page/asm-partner-scope-overview-page.component').then(
        m => m.AsmPartnerScopeOverviewPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_SCOPES],
  ),
  RouterTools.ofLazy(
    AsmRouteId.partner_scopes_scope_modules,
    () =>
      import('@asm/components-partner-management/components/partner/asm-partner-scope-modules-page/asm-partner-scope-modules-page.component').then(
        m => m.AsmPartnerScopeModulesPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_SCOPES],
  ),

  // Access management
  RouterTools.ofRedirect(AsmRouteId.partner_access_management, AsmRouteId.partner_users),
  RouterTools.ofLazy(
    AsmRouteId.partner_users,
    () =>
      import('@asm/components-access-management/components/access-management/asm-users-page/asm-users-page.component').then(
        m => m.AsmPartnerUsersPageComponent,
      ),
    [[AsmAuthority.VIEW_PARTNER_USERS, AsmAuthority.VIEW_PARTNER_SCOPE_USERS]],
  ),
  RouterTools.ofLazy(
    AsmRouteId.partner_roles,
    () =>
      import('@asm/components-access-management/components/access-management/asm-roles-page/asm-roles-page.component').then(
        m => m.AsmPartnerRolesPageComponent,
      ),
    [[AsmAuthority.VIEW_PARTNER_ROLES, AsmAuthority.VIEW_PARTNER_SCOPE_ROLES]],
  ),
  RouterTools.ofRedirect(AsmRouteId.partner_api, AsmRouteId.partner_api_tokens),
  RouterTools.ofLazy(
    AsmRouteId.partner_api_tokens,
    () =>
      import('@asm/components-access-management/components/access-management/asm-api-tokens-page/asm-api-tokens-page.component').then(
        m => m.AsmPartnerApiTokensPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_API],
  ),
  RouterTools.ofLazy(
    AsmRouteId.partner_api_docs,
    () =>
      import('@asm/components-access-management/components/access-management/asm-api-docs-page/asm-api-docs-page.component').then(
        m => m.AsmPartnerApiDocsPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_API],
  ),

  // Resources
  RouterTools.ofRedirect(AsmRouteId.partner_resources, AsmRouteId.partner_settings),

  // Settings
  RouterTools.ofRedirect(AsmRouteId.partner_settings, AsmRouteId.partner_settings_rules),
  RouterTools.ofLazy(
    AsmRouteId.partner_settings_definitions,
    () =>
      import('@asm/components-platform-administration/components/settings/asm-settings-definitions-page/asm-settings-definitions-page.component').then(
        m => m.AsmSettingsDefinitionsPageComponent,
      ),
    [AsmAuthority.MANAGE_PARTNER_SETTINGS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.partner_settings_rules,
    () =>
      import('@asm/components-platform-administration/components/settings/asm-settings-rules-list-page/asm-settings-rules-list-page.component').then(
        m => m.AsmSettingsRulesListPageComponent,
      ),
    [[AsmAuthority.MANAGE_PARTNER_SETTINGS, AsmAuthority.MANAGE_SCOPE_SETTINGS]],
  ),

  // Monitoring
  RouterTools.ofRedirect(AsmRouteId.partner_monitoring, AsmRouteId.partner_integrations),
  RouterTools.ofLazy(
    AsmRouteId.partner_integrations,
    () =>
      import('@asm/components-partner-management/components/partner/asm-partner-integrations-page/asm-partner-integrations-page.component').then(
        m => m.AsmPartnerIntegrationsPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_INTEGRATIONS],
  ),
  RouterTools.ofLazy(
    AsmRouteId.partner_auditLogs,
    () =>
      import('@asm/components-platform-administration/components/settings/asm-audit-logs-page/asm-audit-logs-page.component').then(
        m => m.AsmAuditLogsPageComponent,
      ),
    [AsmAuthority.VIEW_PARTNER_AUDIT_LOGS],
  ),

  // Usage — Overview (KPIs + consumption charts) and Events tabs render the same component.
  RouterTools.ofRedirect(AsmRouteId.partner_usage, AsmRouteId.partner_usage_overview),
  RouterTools.ofLazy(
    AsmRouteId.partner_usage_overview,
    () =>
      import('@asm/components-usage/components/shared/asm-usage-page/asm-usage-page.component').then(
        m => m.AsmUsagePageComponent,
      ),
    [AsmAuthority.FEATURE_BILLING, AsmAuthority.VIEW_PARTNER_SCOPES],
  ),
  RouterTools.ofLazy(
    AsmRouteId.partner_usage_events,
    () =>
      import('@asm/components-usage/components/shared/asm-usage-page/asm-usage-page.component').then(
        m => m.AsmUsagePageComponent,
      ),
    [AsmAuthority.FEATURE_BILLING, AsmAuthority.VIEW_PARTNER_SCOPES],
  ),
];
